import { Routes } from '@angular/router';
import { ConstructionPartRepository } from './repository/construction-part.repository';

export const constructionPartsRoutes: Routes = [
  {
    path: 'construction-parts',
    title: 'Bauelemente',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/select/select.component'),
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/main/main.component'),
        providers: [ConstructionPartRepository],
      },
    ],
  },
];
